import { Store } from "../../../types"
import { useState, useEffect } from "react"
import StoreReportProductList from "./products/StoreReportProductList"
import StoreReportCategoriesList from "./categories/StoreReportCategoriesList"
import StoreReportBrandsList from "./brands/StoreReportBrandsList"
import StoreReportRangesList from "./ranges/StoreReportRangesList"
import StoreReportProductCategoryList from "./productCategories/StoreReportProductCategoryList"
import { useForceSync } from "./useForceSync"

type Props =
    {
        store: Store
    }

const SHOW_COMING_SOON_TABS: boolean = false;

export default function StoreReportMenu({ store }: Props) {
    const [activeTab, setActiveTab] = useState('products');
    const { forceSyncAll: forceSyncProducts, forceSyncSelection: forceSyncSelectedProducts, syncing: syncingProducts } = useForceSync(store, 'Product');
    const { forceSyncAll: forceSyncCategories, forceSyncSelection: forceSyncSelectedCategories, syncing: syncingCategories } = useForceSync(store, 'Category');
    const { forceSyncAll: forceSyncBrands, forceSyncSelection: forceSyncSelectedBrands, syncing: syncingBrands } = useForceSync(store, 'Brand');
    const { forceSyncAll: forceSyncRanges, forceSyncSelection: forceSyncSelectedRanges, syncing: syncingRanges } = useForceSync(store, 'ProductRange');

    const getContent: (type: string) => void = (type: string) => {
        setActiveTab(type);
    };

    useEffect(() => {
        updateContent();
    }, []);

    const updateContent: () => void = () => {

    }

    return (
        <div className="div-tabs reportTable">
            <div className="tabs">
                <button className={`button ${activeTab === 'products' ? 'active' : 'inactive'}`} onClick={() => getContent("products")}>Products</button>
                <button className={`button ${activeTab === 'categories' ? 'active' : 'inactive'}`} onClick={() => getContent("categories")}>Categories</button>
                <button className={`button ${activeTab === 'brands' ? 'active' : 'inactive'}`} onClick={() => getContent("brands")}>Brands</button>
                <button className={`button ${activeTab === 'ranges' ? 'active' : 'inactive'}`} onClick={() => getContent("ranges")}>Product Ranges</button>
                {SHOW_COMING_SOON_TABS && (
                    <>
                        <button className={`button ${activeTab === 'variants' ? 'active' : 'inactive'}`} onClick={() => getContent("variants")}>Product Variants</button>
                        <button className={`button ${activeTab === 'product-categories' ? 'active' : 'inactive'}`} onClick={() => getContent("product-categories")}>Products Categories</button>
                    </>
                )}
            </div>

            <div className="div-content">
                <div aria-disabled={activeTab === 'products'} className={`tab-content ${activeTab === 'products' ? 'active' : 'disabled'}`}>
                    <StoreReportProductList store={store} onForceSyncAll={forceSyncProducts} onForceSyncSelection={forceSyncSelectedProducts} isSyncing={syncingProducts}></StoreReportProductList>
                </div>
                <div aria-disabled={activeTab === 'categories'} className={`tab-content ${activeTab === 'categories' ? 'active' : 'disabled'}`}>
                    <StoreReportCategoriesList store={store} onForceSyncAll={forceSyncCategories} onForceSyncSelection={forceSyncSelectedCategories} isSyncing={syncingCategories}></StoreReportCategoriesList>
                </div>
                <div aria-disabled={activeTab === 'brands'} className={`tab-content ${activeTab === 'brands' ? 'active' : 'disabled'}`}>
                    <StoreReportBrandsList store={store} onForceSyncAll={forceSyncBrands} onForceSyncSelection={forceSyncSelectedBrands} isSyncing={syncingBrands}></StoreReportBrandsList>
                </div>
                <div aria-disabled={activeTab === 'ranges'} className={`tab-content ${activeTab === 'ranges' ? 'active' : 'disabled'}`}>
                    <StoreReportRangesList store={store} onForceSyncAll={forceSyncRanges} onForceSyncSelection={forceSyncSelectedRanges} isSyncing={syncingRanges}></StoreReportRangesList>
                </div>
                {SHOW_COMING_SOON_TABS && (
                    <>
                        <div aria-disabled={activeTab === 'variants'} className={`tab-content ${activeTab === 'variants' ? 'active' : 'disabled'}`}>
                            <p className="comingSoon">Coming soon...</p>
                        </div>
                        <div aria-disabled={activeTab === 'product-categories'} className={`tab-content ${activeTab === 'product-categories' ? 'active' : 'disabled'}`}>
                            <StoreReportProductCategoryList store={store}></StoreReportProductCategoryList>
                        </div>
                    </>
                )}
            </div>
        </div>
    )
}